module.exports = __webpack_public_path__ + "static/01-d719555c7dcab6f7df4e729d5b8fdeaa.jpg";